import type { JSX } from "react";

import { useAuth } from "../../common/auth/AuthProvider.js";
import { frontendConfig } from "../../common/api/config.js";
import { useMe } from "../../common/query/me.js";

export function ProfilePage(): JSX.Element {
  const { signOut } = useAuth();
  const me = useMe(true);

  return (
    <div className="mx-auto w-full max-w-3xl px-4 pb-6">
      <h1 className="pt-4 text-[22px] font-extrabold tracking-[-0.03em] text-ink">Profil</h1>

      <div className="card pad mt-5">
        <p className="micro">Konto</p>
        <p className="mt-1 text-[15px] font-bold text-ink">{me.data?.displayName ?? "—"}</p>
        <p className="text-[13px] text-ink-2">{me.data?.email ?? ""}</p>
      </div>

      {me.data && me.data.memberships.length > 0 && (
        <div className="card pad mt-3">
          <p className="micro">Mitgliedschaften</p>
          <ul className="mt-2 flex flex-col gap-1.5">
            {me.data.memberships.map((entry) => (
              <li key={entry.tenantId} className="flex items-center justify-between gap-3">
                <span className="truncate text-[14px] font-semibold text-ink">
                  {entry.tenantName}
                </span>
                <span className="num text-[11px] font-extrabold uppercase text-ink-3">
                  {entry.role}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <button type="button" className="btn ghost wide mt-5" onClick={() => void signOut()}>
        Abmelden
      </button>

      {/* Welche Fassung läuft — steht in /api/config und gehört sichtbar ins Konto-Menü. */}
      <p className="num mt-6 text-center text-[11px] text-ink-3">{frontendConfig().version}</p>
    </div>
  );
}
